import * as moment from 'moment';
import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { CustomerInfo } from '../../reservation/models/reservation.model';
import { Store } from '../../store/models/store.model';
import { QueueStatus } from '../enums/queue-status.enum';
import { QueueEvent } from './queue-event.model';

export class Queue {
	uuid: string;
	status: QueueStatus;
	store: Store;
	quota: number;
	dateTime: Date | string;
	user: CustomerInfo; // cliente consumidor que fez a própria reserva
	customerInfo: CustomerInfo; // estabelecimento que fez a própria reserva
	events: Array<QueueEvent>;
	queueNumber: string;

	// auxilia na tela
	customer: CustomerInfo;

	constructor(obj: any = { }) {
		Object.assign(this, obj);

		if (this.queueNumber && this.queueNumber.length > 0) {
			this.queueNumber = this.queueNumber.toString().slice(-3);
		}

		if (this.status != null && this.status['code'] == null) {
			this.status = UtilHelper.getEnumByCod(this.status, QueueStatus);

			if (this.status == null) {
				this.status = QueueStatus.UNDEFINED;
			}
		}
		this.dateTime = moment(this.dateTime).toDate();
		
		// Para facilitar as visualizações na tela, seto no objeto auxiliar customer as infos do usuário
		if (this.user) {
			this.customer = this.user;
			if (this.user.phone) {
				if (!this.user.countryPhoneCode || UtilHelper.unmask(this.user.countryPhoneCode) == "55") {
					this.customer.phone = UtilHelper.mask(this.user.phone, this.user.phone.length > 10 ? "(99) 99999-9999" : "(99) 9999-9999");
				}
				this.customer.countryPhoneCode = UtilHelper.unmask(this.user.countryPhoneCode);
			}
		} else if (this.customerInfo) {
			this.customer = this.customerInfo;
			if (this.customerInfo.phone) {
				if (!this.customerInfo.countryPhoneCode || UtilHelper.unmask(this.customerInfo.countryPhoneCode) == "55") {
					this.customer.phone = UtilHelper.mask(this.customerInfo.phone, this.customerInfo.phone.length > 10 ? "(99) 99999-9999" : "(99) 9999-9999");
				}
				this.customer.countryPhoneCode = UtilHelper.unmask(this.customerInfo.countryPhoneCode);
			}
		}

		if (this.events && this.events.length > 0) {
			let queueEvents: Array<QueueEvent> = [];
			this.events.forEach((q) => {
				queueEvents.push(new QueueEvent(q));
			});
			this.events = queueEvents;
		}
	}

	toJsonCreate(): any {
		const json: any = {
			store: { id: this.store.id },
			quota: Number(this.quota),
			customerInfo: this.customerInfo
		};
		json.customerInfo.phone = UtilHelper.unmask(this.customerInfo.phone);
		return json;
	}

	toJsonUpdate(): any {
		const json: any = {
			uuid: this.uuid,
			store: { id: this.store.id },
			quota: Number(this.quota)
		};
		if (this.user) {
			json.user = { id: this.user.id };
		} else if (this.customerInfo) {
			json.customerInfo = this.customerInfo;
			json.customerInfo.phone = UtilHelper.unmask(this.customerInfo.phone);
		}
		return json;
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/queue/models/queue.model.ts